<template>
  <path
    d="M12 8.00024C13.1 8.00024 14 7.10024 14 6.00024C14 4.90024 13.1 4.00024 12 4.00024C10.9 4.00024 10 4.90024 10 6.00024C10 7.10024 10.9 8.00024 12 8.00024ZM12 10.0002C10.9 10.0002 10 10.9002 10 12.0002C10 13.1002 10.9 14.0002 12 14.0002C13.1 14.0002 14 13.1002 14 12.0002C14 10.9002 13.1 10.0002 12 10.0002ZM12 16.0002C10.9 16.0002 10 16.9002 10 18.0002C10 19.1002 10.9 20.0002 12 20.0002C13.1 20.0002 14 19.1002 14 18.0002C14 16.9002 13.1 16.0002 12 16.0002Z"
  />
</template>
